import { render, staticRenderFns } from "./SalaryProRetoucherTable.vue?vue&type=template&id=1354be1f&"
import script from "./SalaryProRetoucherTable.vue?vue&type=script&lang=js&"
export * from "./SalaryProRetoucherTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports